import { ISnake } from 'src/types';
import cn from 'classnames';
import { observer } from 'mobx-react-lite';
import { useStoreContext } from 'store/app';
import { useCallback, useMemo, useState } from 'react';
import { useTranslationsContext } from 'store/translations';

import './lootboxSnakeCard.styl';
import { Button } from 'components/core';
import { CollectionModal } from 'components/modal/collectionModal';
import OKSDK from '@odnoklassniki/ok-apps-sdk';

interface Props {
    snake: ISnake;
    className?: string;
    onSelect?: (snake: ISnake) => void;
}

export const LootboxSnakeCard = observer(({ snake, className, onSelect }: Props) => {
    const [collectionModalVisible, setCollectionModalVisible] = useState(false);
    const { translate } = useTranslationsContext();
    const { catalogConfig, userState, isAnonym, isNative, logOperation } = useStoreContext();
    const {
        custom_params: { title, bg, img, shadow }
    } = snake;

    const relatedCollection = useMemo(() => {
        return catalogConfig?.collections.find((collect) => collect.snakes.includes(snake.id))!;
    }, [snake, catalogConfig]);

    const tryLogin = () => {
        if (isNative) {
            let url = '/apphook/nativeLogin?link=' + encodeURIComponent(`/app/collections`);
            window.parent.location.href = url;
        } else {
            OKSDK.Methods.Layers.showLoginSuggestion('{}').then(({ status, data }) => {
                status == 'error' && data === 'cancel' && logOperation('anonym_rules', 'auth_cancel');
            });
        }
    };

    const onMoreClick = () => {
        logOperation('snake_choice', 'more_info', snake.id);
        setCollectionModalVisible(true);
    };

    const hasAnySnakes = useMemo(() => {
        return (
            userState?.free_snakes?.length ||
            userState?.collections?.some((collection) => collection.snakes && collection.snakes.length > 0)
        );
    }, [userState]);

    const onButtonClick = useCallback(() => {
        if (isAnonym) {
            logOperation('anonym_rules', 'auth_init');
            tryLogin();
        } else {
            logOperation(hasAnySnakes ? 'snake_choice' : 'onboard', 'snake_choice', snake.id);
            onSelect?.(snake);
        }
    }, [isAnonym, hasAnySnakes]);

    return (
        <div className={cn('lootbox-snake-card', className)} style={{ background: bg, boxShadow: shadow }}>
            <div className="lootbox-snake-card-title">{title}</div>
            <div className="lootbox-snake-card-desc">
                {relatedCollection.custom_params.title || relatedCollection.name}
            </div>
            <div className="lootbox-snake-card-buttons">
                <Button className="lootbox-snake-card-button" onClick={onButtonClick}>
                    {translate('lootbox.select')}
                </Button>
                {hasAnySnakes ? (
                    <Button className="lootbox-snake-card-button more" onClick={onMoreClick}>
                        {translate('lootbox.more', {}, 'Подробнее')}
                    </Button>
                ) : null}
            </div>

            <img className="lootbox-snake-card-image" src={img}></img>
            <CollectionModal
                isOpened={collectionModalVisible}
                collectionId={relatedCollection.id}
                onClose={() => setCollectionModalVisible(false)}
            ></CollectionModal>
        </div>
    );
});
